var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9829 10.182L23.0245 15.1819C23.0661 20.1817 21.0828 22.1983 16.083 22.2399L10.0832 22.2898C5.08334 22.3314 3.06677 20.3481 3.02517 15.3483L2.97524 9.34848C2.93363 4.34866 4.91692 2.33208 9.91675 2.29048L14.9166 2.24887",
    stroke: "#9F55FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9828 10.182L18.9829 10.2153C15.983 10.2403 14.9748 9.24863 14.9498 6.24873L14.9165 2.24887L22.9828 10.182Z",
    stroke: "#9F55FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.8147bfe8234e2e08058d0ef822bba710.svg";
export { ForwardRef as ReactComponent };